module.exports = __webpack_public_path__ + "static/media/card-success.79a8823f.jpg";